<template>
  <v-dialog :value="show" persistent max-width="520" @input="$emit('close')">
    <v-card class="ec-card">
      <admin-table-subheader
        title="Approve Application"
        close-button
        @close="$emit('close')"
      />

      <div class="pa-body">
        <p class="pa-intro">
          Approving <strong>{{ application.company_name }}</strong> marks the application as
          approved. Optionally create the matching partner record so pools and portal users can
          be assigned right away.
        </p>

        <v-switch
          v-model="createReseller"
          label="Create partner (reseller) record"
          color="primary"
          inset
          hide-details
        />

        <template v-if="createReseller">
          <label class="pa-label">Partner Name</label>
          <v-text-field v-model="name" dense outlined />

          <label class="pa-label">Slug (optional — generated from name if empty)</label>
          <v-text-field v-model="slug" dense outlined placeholder="avermedia" />

          <label class="pa-label">Commission Rate (%)</label>
          <v-text-field
            v-model.number="commissionPercent"
            type="number" min="0" max="100"
            dense outlined suffix="%"
          />

          <p class="pa-hint">
            The partner is not shown on the public site until its showcase fields are filled in
            and it is explicitly made public.
          </p>
        </template>

        <label class="pa-label">Review note (optional)</label>
        <v-textarea v-model="reviewNote" dense outlined rows="3" />

        <div v-if="formError" class="pa-error">
          <v-icon size="15" color="#dc2626" style="margin-right:6px">mdi-alert-circle-outline</v-icon>
          {{ formError }}
        </div>
      </div>

      <div class="pa-footer">
        <button class="ec-btn ec-btn--ghost" @click="$emit('close')">Cancel</button>
        <button class="ec-btn ec-btn--primary" :disabled="saving" @click="approve">
          <v-progress-circular v-if="saving" size="13" width="2" indeterminate style="margin-right:6px" />
          Approve
        </button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiService } from '../../service/api.service'
import AdminTableSubheader from '../shared/AdminTableSubheader.vue'

export default {
  name: 'PartnerApplicationApprove',
  components: { AdminTableSubheader },
  props: {
    show: { type: Boolean, default: false },
    application: { type: Object, required: true }
  },
  data () {
    return {
      saving: false,
      formError: '',
      createReseller: true,
      name: this.application.company_name,
      slug: '',
      commissionPercent: 30,
      reviewNote: ''
    }
  },
  methods: {
    async approve () {
      this.saving = true
      this.formError = ''

      const payload = {
        create_reseller: this.createReseller,
        review_note: this.reviewNote || null
      }
      if (this.createReseller) {
        payload.name = this.name
        payload.commission_rate = Number(this.commissionPercent) / 100
        if (this.slug) payload.slug = this.slug
      }

      await apiService.post(`admin/partner-applications/${this.application.id}/approve`, payload)
        .then(() => { this.$emit('approved') })
        .catch((err) => { this.formError = err.response?.data?.message || 'Operation failed' })
        .finally(() => (this.saving = false))
    }
  }
}
</script>

<style scoped>
.pa-body { padding: 18px 20px; }
.pa-intro { margin: 0 0 12px; font-size: .84rem; line-height: 1.6; color: var(--ec-text-2); }
.pa-label { display:block; font-size:.78rem; font-weight:600; color:var(--ec-text-2); margin:12px 0 2px; }
.pa-hint { margin: 0 0 4px; font-size: .76rem; line-height: 1.55; color: var(--ec-text-2); }
.pa-footer { display:flex; justify-content:flex-end; gap:8px; padding:12px 20px; border-top:1px solid var(--ec-border); }
.pa-error { display:flex; align-items:center; margin-top:12px; padding:8px 12px; border-radius:8px; background:#fef2f2; color:#dc2626; font-size:.82rem; }
</style>
